import _isArray from 'lodash-es/isArray';
import { CustomFieldDefinition } from 'types/customField';
import { OldFieldValueType, OldCustomFieldOption } from 'types/oldCustomField';
import { normalize } from '@teetsh/app/src/utils/normalize';
import { v4 as uuid } from 'uuid';

export function convertOptionsFromSourceToTarget(
  sourceFieldDefinition: CustomFieldDefinition,
  targetFieldDefinition: CustomFieldDefinition,
  value: OldFieldValueType,
): {
  missingOptions: OldCustomFieldOption[];
  sourceIdToTargetIdMap: Map<string, string>;
} {
  const sourceIdToTargetIdMap = new Map<string, string>();
  if (
    targetFieldDefinition.type !== 'select' ||
    sourceFieldDefinition.type !== 'select'
  ) {
    return { missingOptions: [], sourceIdToTargetIdMap };
  }
  if (!_isArray(value)) {
    return { missingOptions: [], sourceIdToTargetIdMap };
  }
  const valueOptions = sourceFieldDefinition.options.filter(opt =>
    value.includes(opt.id),
  );

  // Process each value option to either map it to an existing target option or mark it as missing
  const missingOptions: OldCustomFieldOption[] = [];

  valueOptions.forEach(sourceOpt => {
    const matchingTargetOpt = targetFieldDefinition.options.find(
      targetOpt => normalize(targetOpt.value) === normalize(sourceOpt.value),
    );

    if (matchingTargetOpt) {
      // Found a matching option in target, map the IDs
      sourceIdToTargetIdMap.set(sourceOpt.id, matchingTargetOpt.id);
    } else {
      // No matching option found, add to missing options with a new ID
      const newId = uuid();
      missingOptions.push({ ...sourceOpt, id: newId });
      sourceIdToTargetIdMap.set(sourceOpt.id, newId);
    }
  });

  return { missingOptions, sourceIdToTargetIdMap };
}
